var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sample-order-app-container", attrs: { id: "app" } },
    [
      _c("progressbar", { attrs: { progressbar: _vm.getProgressbar } }),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.currentStep === 1
            ? [
                _c(
                  "div",
                  { staticClass: "col col-12 col-lg-9" },
                  [
                    _c("color-sample-overview", {
                      attrs: {
                        items: _vm.items,
                        "action-url": _vm.actionURL,
                        structures: _vm.structures,
                        currency: _vm.currency,
                        "can-modify-quantity": _vm.canModifyQuantity,
                      },
                      on: { updateCartData: _vm.onUpdateCartData },
                    }),
                    _vm.shades.length > 0 && _vm.items.length == 1
                      ? _c("color-sample-shades", {
                          attrs: { shades: _vm.shades },
                          on: { updateCartData: _vm.onUpdateCartData },
                        })
                      : _vm._e(),
                    _vm.combinations.length > 0 && _vm.items.length == 1
                      ? _c("color-sample-combinations", {
                          attrs: { combinations: _vm.combinations },
                          on: { updateCartData: _vm.onUpdateCartData },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-lg-3" },
                  [
                    _c("color-sample-side-bar", {
                      attrs: {
                        getSubtotal: _vm.getSubtotal,
                        getOptionalCost: _vm.getOptionalCost,
                        getVat: _vm.getVat,
                        getTotal: _vm.getTotal,
                        currentStep: _vm.currentStep,
                        getCheckoutClasses: _vm.getCheckoutClasses(),
                        paymentMethods: _vm.paymentMethods,
                        getVatPercent: _vm.getVatPercent,
                      },
                      on: {
                        back: _vm.back,
                        forward: _vm.forward,
                        pay: _vm.pay,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.currentStep === 2
            ? [
                _c("div", { staticClass: "col-12 col-lg-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("span", { staticClass: "color-order-billing-title" }, [
                        _vm._v(_vm._s(_vm.trans("sample_order_step2_title"))),
                      ]),
                      _c(
                        "span",
                        { staticClass: "color-order-billing-subtitle pb-3" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.trans("sample_order_step2_required_info")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-lg-12" },
                      [
                        _vm.currentStep === 2
                          ? _c("color-sample-checkout", {
                              attrs: {
                                forwardclass: _vm.getCheckoutClasses(),
                                showValidate: _vm.showValidate,
                                items: _vm.items,
                                currency: _vm.currency,
                              },
                              on: {
                                back: _vm.back,
                                forward: _vm.forward,
                                customerData: _vm.onCustomerDataChanged,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm.currentStep === 3
            ? [
                _c(
                  "div",
                  { staticClass: "col col-12 col-lg-9" },
                  [
                    _vm.currentStep === 3
                      ? _c("color-sample-payment", {
                          attrs: {
                            items: _vm.items,
                            currency: _vm.currency,
                            "customer-data": _vm.customerData,
                          },
                          on: { back: _vm.back },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-lg-3" },
                  [
                    _c("color-sample-side-bar", {
                      attrs: {
                        getSubtotal: _vm.getSubtotal,
                        getOptionalCost: _vm.getOptionalCost,
                        getVat: _vm.getVat,
                        getTotal: _vm.getTotal,
                        currentStep: _vm.currentStep,
                        getCheckoutClasses: _vm.getCheckoutClasses(),
                        paymentMethods: _vm.paymentMethods,
                        getVatPercent: _vm.getVatPercent,
                      },
                      on: {
                        back: _vm.back,
                        forward: _vm.forward,
                        pay: _vm.pay,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }